import React from 'react';

export default function NameCell(cellData) {
    if (cellData.column.dataField == 'shortName') {
        return (
            <div className={cellData.data.itemType}>{cellData.value}</div>
        );
    }

    var cn = "value_" + cellData.data.itemType;

    if (cellData.column.dataField == 'totalValue') {
        return (
            <div className={cn}>{cellData.value.toLocaleString(
                undefined,                
                { minimumFractionDigits: 2 }
            )}</div>
        );
    }
    if (cellData.column.dataField == 'percent') {
        var val = (cellData.value * 100).toLocaleString('ru-RU', {
            maximumFractionDigits: 2,
            minimumFractionDigits: 2
        });
        return (
            <div className={cn}>{val}%</div>
        );
    }
}


// WEBPACK FOOTER //
// ./App/containers/position/NameCell.jsx